import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Box,
  TablePagination,
  IconButton,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import Edit from "../assets/svg/Edit";
import Delete from "../assets/svg/Delete";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import styled from "styled-components";
import { colors } from "../utils/colors/Index";
import { useState } from "react";

const PlanTable = ({
  planData,
  setFormData,
  setEdit,
  handleDelete,
  setFileName,
}) => {
  console.log(planData, "planData");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(4);

  const [openQR, setOpenQR] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = planData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleEditClick = (row) => {
    console.log(row);

    setFormData({
      planname: row?.name,
      duration: row?.duration,
      price: row?.price,
      _id: row?._id,
      upi: row?.upi,
      qrCode: row?.qr,
      discount: parseInt(row?.discount, 10) || 0,
    });
    setFileName(row?.qr ? row.qr.split("/").pop() : null);
    setEdit(true);
  };

  const handleViewQR = (row) => {
    setSelectedPlan(row);
    setOpenQR(true);
  };

  return (
    <>
      <StyledTableContainer component={Paper}>
        <Table>
          <StyledTableHead>
            <StyledTableRow>
              <StyledTableCell align="left">Plan Name</StyledTableCell>
              <StyledTableCell align="left">Duration (month)</StyledTableCell>
              <StyledTableCell align="center">Price</StyledTableCell>
              <StyledTableCell align="center">Discount%</StyledTableCell>
              <StyledTableCell align="center">QR Code</StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </StyledTableRow>
          </StyledTableHead>
          <TableBody>
            {paginatedData.map((row, index) => (
              <StyledTableRow key={`${row.name}-${index}`}>
                <StyledBodyCell align="left">{row.name}</StyledBodyCell>
                <StyledBodyCell align="center">{row.package}</StyledBodyCell>
                <StyledBodyCell align="center">{row.price}</StyledBodyCell>
                <StyledBodyCell align="center">{row.discount}</StyledBodyCell>

                {/* QR column */}
                <StyledBodyCell align="center">
                  <IconButton onClick={() => handleViewQR(row)}>
                    <VisibilityIcon sx={{ fontSize: "1.2rem" }} />{" "}
                    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                      View QRCode
                    </Typography>
                  </IconButton>
                </StyledBodyCell>

                <StyledBodyCell align="center">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <IconButton onClick={() => handleEditClick(row)}>
                      <Edit />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(row?._id)}>
                      <Delete />
                    </IconButton>
                  </Box>
                </StyledBodyCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>

        {planData.length > 4 && (
          <TablePagination
            rowsPerPageOptions={[4, 8, 10]}
            component="div"
            count={planData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </StyledTableContainer>

      {/* QR Code Popup */}
      <Dialog open={openQR} onClose={() => setOpenQR(false)}>
        <DialogContent sx={{ textAlign: "center", position: "relative" }}>
          <IconButton
            onClick={() => setOpenQR(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
          {selectedPlan && (
            <>
              <Typography variant="h6" fontWeight="bold">
                {selectedPlan.name}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                ₹ {selectedPlan.price}
              </Typography>
              <Box mt={2}>
                <img
                  src={selectedPlan.qr}
                  alt="QR Code"
                  style={{ width: 200, height: 200 }}
                />
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PlanTable;

const StyledTableContainer = styled(TableContainer)({
  backgroundColor: colors.white,
});

const StyledTableHead = styled(TableHead)({
  backgroundColor: "#f2f2f2",
});

const StyledTableRow = styled(TableRow)({
  border: `1px solid #dcdcdc`,
});

const StyledTableCell = styled(TableCell)({
  border: `1px solid #dcdcdc`,
  fontWeight: 600,
  color: colors.text.primary,
});

const StyledBodyCell = styled(TableCell)({
  border: `1px solid #dcdcdc`,
  color: colors.text.secondary,
});
